import React, {Component, createContext, useLayoutEffect, useState} from 'react';
import {withNotification} from "./NotificationContext";
import DefaultPage from "../views/DefultPage";
import {withRouter} from "react-router-dom";
import {useAuth, useFirestore} from 'reactfire';
import PendencyObj from '../models/pendency';
import formatDate from '../utils/formatDate';
import moment from 'moment';
import Pendency from '../forms/Pendency';
import localforage from '../utils/localforage';

const Context = createContext({});

const Provider = React.forwardRef(({children: Children, ...props}, ref) => {
    return <Context.Provider value={props} ref={ref}>
        {Children}
    </Context.Provider>;
});

const {Consumer} = Context;

export const ConsumerFb = Consumer;

export const withFb = (Child) => class WithFbData extends Component {
    render() {
        return <Consumer>
            {
                fbData => <Child {...this.props} {...fbData} ref={fbData.ref}/>
            }
        </Consumer>
    }
};

const FbProvider = React.forwardRef((props, ref) => {
    const [pendency, setPendency] = useState();
    const [listTempPendency, setListTempPendency] = useState([]);
    const [auth, setAuth] = useState({})
    const Auth = useAuth();
    const firestore = useFirestore();
    useLayoutEffect(() => {
        Auth.onAuthStateChanged(currentUser => setAuth(currentUser))
    }, [])
    let exportObjects = {
        auth
    };
    if(auth?.uid) {
        const dbPlayer = firestore.collection(auth.uid).doc('player');
        const dbTemp = firestore.collection(auth.uid).doc('temp').collection('pendencies');
        let data = props.data;
        data.setProps({
            notification: props.notification,
            history: props.history,
            pendency,
            setPendency,
            listTempPendency,
            setListTempPendency,
            db:firestore,
            dbPlayer,
            dbTemp,
        }).then();

        const addTempPendency = async (refresh = false, error = false) => {
            const newPendency = await localforage.getItem('novo-apontamento') ?? pendency ?? PendencyObj;
            newPendency.dataHoraInicio = newPendency.dataHoraFim;
            if(!refresh){
                newPendency.status = null;
                newPendency.requestMessage = null;
                newPendency.dataHoraInicio = formatDate(moment(newPendency.dataHoraFim));
                newPendency.dataHoraFim = '';
            }
            window.dialogWindow.open({
                noActionButtons: true,
                title: 'Adicionar Temporário',
                content: <Pendency
                    data={newPendency}
                    disableCloseOnSubmit={true}
                    dateTime
                    isNew={!refresh}
                    withError={error}
                    temp
                    onSubmit={(initialValues, pendency) => {
                        data.add(pendency);
                        window.dialogWindow.close();
                    }
                    }/>,
                size: 'md'
            });
        };
        exportObjects = {
            ...exportObjects,
            addTempPendency,
            pendency,
            setPendency,
            listTempPendency,
            setListTempPendency,
            data,
            db:firestore,
            notification: props.notification,
            ref
        };
        return <Provider {...props} {...exportObjects} ref={ref}/>;
    }
    return <DefaultPage ref={ref}/>;
});

export default withRouter(withNotification(FbProvider));
